export default "__VITE_ASSET__DJTQ8MT$__"